export function addCurrent(defaultaction) {
  return {
      type: 'ADD_CURRENT',
      defaultaction,
  }
}